__turbopack_context__.v({
  "border": "CosmeticWrapper-module-scss-module__cDkATW__border",
  "cssFrame": "CosmeticWrapper-module-scss-module__cDkATW__cssFrame",
  "glow": "CosmeticWrapper-module-scss-module__cDkATW__glow",
  "texture": "CosmeticWrapper-module-scss-module__cDkATW__texture",
  "wrapper": "CosmeticWrapper-module-scss-module__cDkATW__wrapper",
});
